<script lang="ts" setup>
import PageLink from '../components/PageLink.vue'
import Banner from '../components/Banner.vue'
import List from './components/List.vue'
import Ad from '../components/Ad.vue'
import Newsletter from '../components/Newsletter.vue'
import { useArticleStore } from '@/stores'
import type { ResponseConfig, IArticleFilter, IArticle, IHomeHenceCard } from '@/utils/types'
import useSeo from './seo'

const route = useRoute()
const categoryId = route.params.categoryId as string
const { advert } = useApi()
const articleStore = useArticleStore()
const category = computed(() => articleStore.projectCategories.find(item => item.id == categoryId))
await articleStore.fetchArticleCategories('projectCategories', {
  className: 'articleProject'
})
const res = ref<ResponseConfig>({
  code: 0,
  data: {} as any,
  message: ''
})
const filter = ref<IArticleFilter>({
  page: 1,
  per_page: 9,
  category_id: categoryId
})

const banners = computed(() => {
  const tops = res.value.data?.top || []
  return tops.map((item: IArticle) => {
    return {
      id: item.id,
      image: item.image?.link ?? '',
      category: item.categories.length > 0 ? item.categories[0].subject : '',
      title: item.subject
    }
  })
})

const articles = computed(() => {
  const lists = res.value.data?.list?.data || []
  return lists.map((item: IArticle) => {
    return {
      image: item.image,
      category: item.categories.length > 0 ? item.categories[0].subject : '',
      title: item.subject,
      link: `/hence/article/${item.id}`
    } as IHomeHenceCard
  })
})

const pageMeta = computed(() => {
  const list = res.value.data?.list
  return list?.meta ?? null
})

const handleChangePage = async (page: number) => {
  const f = {
    ...filter.value,
    page,
  }
  res.value = await articleStore.fetchArticles(f)
  navigateTo({ path: route.path, query: { page } })
}

handleChangePage(parseInt(route.query.page as string) || 1)

const { data: advertData } = await advert.getAdvert('hence-list')
const advertRes = computed(() => advertData.value?.data)

useSeo(category.value)
</script>

<template>
  <section class="hence">
    <div class="hence__top">
      <!-- <div class="hence__top__logo">
        <Nimg src="./images/hence_logo.svg" format="" />
      </div> -->
      <h1 class="hence__top__title">{{ category?.subject }}</h1>
      <PageLink />
    </div>
    <Banner :banners="banners" v-if="banners.length > 0" />
    <List :items="articles" :handleChangePage="handleChangePage" :meta="pageMeta" />
    <Ad :data="advertRes" v-if="advertRes" />
    <Newsletter class="hence__full" />
  </section>
</template>

<style lang="scss" scoped>
.hence {
  @include max-media(767) {
    position: relative;
    z-index: 2;
    transform: translateY(toRem(100));
    margin-top: toRem(-100);
  }

  &__top {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__logo {
      width: 100%;
      max-width: toRem(276);

      img {
        display: block;
        width: 100%;
      }
    }

    &__title {
      margin-bottom: toRem(40);
      font-size: toRem(28);
      font-weight: 500;
      line-height: 1.3;
    }
  }

  &__full {
    margin-left: toRem(-24);
    margin-right: toRem(-24);
  }
}
</style>
